import React from "react";
import trustedDeviceStyles from "./TrustedDevices.module.scss"; // Adjust the path as needed

interface BiometricFormComponentProps {
  onSubmitHandler: (event: React.FormEvent<HTMLFormElement>) => void;
}

const BiometricFormComponent: React.FC<BiometricFormComponentProps> = ({ onSubmitHandler }) => {
  return (
    <form
      hidden={true}
      onSubmit={onSubmitHandler}
      className={trustedDeviceStyles.biometricForm}
      id="biometric_placeholder"
    >
      {/* After gathering user fingerprint, CIDM code tries to find input with id loginButton_0 and click on it */}
      <input hidden={true} type="submit" id="loginButton_0" />
      <div id="wrapper">
        <fieldset></fieldset>
      </div>
    </form>
  );
};

export default BiometricFormComponent;
